var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st10{fill:#003750;}\n\t.st11{fill:#043750;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M403.7,88.09h-35.76V69.44c0-6.87-5.57-12.44-12.44-12.44s-12.44,5.57-12.44,12.44V88.1H168.94V69.44 c0-6.87-5.57-12.44-12.44-12.44s-12.44,5.57-12.44,12.44V88.1H108.3C80.01,88.09,57,111.11,57,139.4v264.3 c0,28.29,23.01,51.3,51.3,51.3h295.4c28.29,0,51.3-23.01,51.3-51.3V139.4C455,111.11,431.99,88.09,403.7,88.09z M108.3,112.97 h35.76v12.44c0,6.87,5.57,12.44,12.44,12.44s12.44-5.57,12.44-12.44v-12.44h174.12v12.44c0,6.87,5.57,12.44,12.44,12.44 s12.44-5.57,12.44-12.44v-12.44h35.76c14.57,0,26.43,11.86,26.43,26.43v29.54H81.88V139.4C81.88,124.82,93.73,112.97,108.3,112.97z  M403.7,430.12H108.3c-14.57,0-26.43-11.86-26.43-26.43V193.81h348.25V403.7C430.12,418.27,418.27,430.12,403.7,430.12z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M304.02,366.8v20.38h-96.03V366.8h38.8V248.16c-8.65,4.47-23.73,10.05-32.1,12.56l-2.79-18.98 c14.24-4.75,32.1-12.84,41.59-18.98h15.91V366.8H304.02z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCalendar);
export default __webpack_public_path__ + "static/media/small-calendar.a26a782474334dc511ccd0b897412426.svg";
export { ForwardRef as ReactComponent };